import { BlockContext } from './BlockContext';
var getLayoutBlockRenderer = function (renderers, type) {
    return renderers[type];
};
export var renderLayoutBlock = function (renderers) {
    return function (layoutBlock, index) {
        var renderer = getLayoutBlockRenderer(renderers, layoutBlock.type);
        if (!renderer) {
            return null;
        }
        return renderer.call(renderers, layoutBlock, BlockContext.BLOCK, index);
    };
};
//# sourceMappingURL=renderLayoutBlock.js.map